import Container from '@ui/container/container';
import ThemePackSecondaryColorComponent from './theme-pack-secondary-color-component';
import type {
  EPaletteModes,
  TColorVariantsExplicit,
  TColorVariantsExplicitOptional,
  ThemePack,
} from '@/types/theme-packs.types';
import { useCallback } from 'react';

type TThemePackColorVariantChangeProps = {
  themeMode: EPaletteModes;
  themePack?: ThemePack;
  disabled?: boolean;
  onThemePackUpdate?: (pack: ThemePack) => void;
};
const ThemePackSecondaryColorChange = ({
  themeMode,
  themePack,
  onThemePackUpdate,
}: TThemePackColorVariantChangeProps) => {
  const handleChange = useCallback(
    (key: keyof (TColorVariantsExplicit & TColorVariantsExplicitOptional)) => (hex: string, opacity: number) => {
      if (!themePack) return null;
      onThemePackUpdate?.({
        ...themePack,
        colors: {
          ...themePack.colors,
          [themeMode]: {
            ...themePack.colors[themeMode],
            [key]: [hex, opacity],
          },
        },
      });
    },
    [onThemePackUpdate, themeMode, themePack]
  );

  if (!themePack) return null;

  const colors = themePack.colors[themeMode] ?? themePack.colors;

  return (
    <Container className="flex ai-center gap-8 jc-center" height="64px" width="100%" margin="0 auto">
      <ThemePackSecondaryColorComponent
        colorArray={colors.secondaryBackgroundColor}
        onChange={handleChange('secondaryBackgroundColor')}
        label="Banner"
      />
      <ThemePackSecondaryColorComponent
        colorArray={colors.backgroundColor}
        onChange={handleChange('backgroundColor')}
        label="Background"
      />
      <ThemePackSecondaryColorComponent
        colorArray={colors.buttonTextColor ?? colors.bodyTextColor}
        onChange={handleChange('buttonTextColor')}
        label="Button text"
      />
      <ThemePackSecondaryColorComponent
        colorArray={colors.headingTextColor}
        onChange={handleChange('headingTextColor')}
        label="Heading text"
      />
      <ThemePackSecondaryColorComponent
        colorArray={colors.bodyTextColor}
        onChange={handleChange('bodyTextColor')}
        label="Description text"
      />
    </Container>
  );
};

export default ThemePackSecondaryColorChange;
